import { useAuth } from './auth';

/**
 * Whether the company's Live sessions switch is on (1.13.0, docs/live-sessions.md): calls and
 * Patches ring on one card, busy status says "In a Patch", and history shows them together.
 * Read from the person's memberships (it takes effect the next time Stitch loads).
 */
export function useLiveSessions(tenant: string | null | undefined): boolean {
  const { state } = useAuth();
  const t = (tenant ?? '').toLowerCase();
  return Boolean(t && state?.memberships?.some((m) => m.tenant?.toLowerCase() === t && m.liveSessions));
}
